import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from '@/context/AuthContext';
import { ProtectedRoute } from '@/components/ProtectedRoute';
import { AdminProtectedRoute } from '@/components/AdminProtectedRoute';
import { Toaster } from '@/components/ui/sonner';
import LandingPage from '@/pages/LandingPage';
import AuthPage from '@/pages/AuthPage';
import Dashboard from '@/pages/Dashboard';
import PGListPage from '@/pages/PGListPage';
import PGVisualLayout from '@/pages/PGVisualLayout';
import PendingRentsPage from '@/pages/PendingRentsPage';
import SetupPage from '@/pages/SetupPage';
import TenantsPage from '@/pages/TenantsPage';
import AddTenantPage from '@/pages/AddTenantPage';
import TenantDetailPage from '@/pages/TenantDetailPage';
import PublicTenantQrPage from '@/pages/PublicTenantQrPage';
import CollectRentPage from '@/pages/CollectRentPage';
import ExpensesPage from '@/pages/ExpensesPage';
import OccupancyPage from '@/pages/OccupancyPage';
import AdminLoginPage from '@/pages/admin/AdminLoginPage';
import AdminDashboard from '@/pages/admin/AdminDashboard';
import AdminOwnersPage from '@/pages/admin/AdminOwnersPage';
import AdminPropertiesPage from '@/pages/admin/AdminPropertiesPage';
import '@/App.css';

function PublicRoute({ children }) {
  const token = localStorage.getItem('token');

  if (token) {
    return <Navigate to="/dashboard" replace />;
  }

  return children;
}

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route
            path="/"
            element={
              <PublicRoute>
                <LandingPage />
              </PublicRoute>
            }
          />
          <Route
            path="/login"
            element={
              <PublicRoute>
                <AuthPage />
              </PublicRoute>
            }
          />
          
          {/* Admin Routes */}
          <Route path="/admin/login" element={<AdminLoginPage />} />
          <Route
            path="/admin/dashboard"
            element={
              <AdminProtectedRoute>
                <AdminDashboard />
              </AdminProtectedRoute>
            }
          />
          <Route
            path="/admin/owners"
            element={
              <AdminProtectedRoute>
                <AdminOwnersPage />
              </AdminProtectedRoute>
            }
          />
          <Route
            path="/admin/pgs"
            element={
              <AdminProtectedRoute>
                <AdminPropertiesPage />
              </AdminProtectedRoute>
            }
          />
          
          {/* User Routes */}
          <Route
            path="/dashboard"
            element={
              <ProtectedRoute>
                <Dashboard />
              </ProtectedRoute>
            }
          />
          <Route
            path="/pgs"
            element={
              <ProtectedRoute>
                <PGListPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/pg-layout/:pgId"
            element={
              <ProtectedRoute>
                <PGVisualLayout />
              </ProtectedRoute>
            }
          />
          <Route
            path="/pgs/:pgId/pending-rents"
            element={
              <ProtectedRoute>
                <PendingRentsPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/setup"
            element={
              <ProtectedRoute>
                <SetupPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/tenants"
            element={
              <ProtectedRoute>
                <TenantsPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/tenants/add"
            element={
              <ProtectedRoute>
                <AddTenantPage />
              </ProtectedRoute>
            }
          />
          <Route path="/tenants/join/:inviteId" element={<PublicTenantQrPage />} />
          <Route
            path="/tenants/:id"
            element={
              <ProtectedRoute>
                <TenantDetailPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/collect-rent"
            element={
              <ProtectedRoute>
                <CollectRentPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/expenses"
            element={
              <ProtectedRoute>
                <ExpensesPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/occupancy"
            element={
              <ProtectedRoute>
                <OccupancyPage />
              </ProtectedRoute>
            }
          />
        </Routes>
        <Toaster position="top-right" richColors />
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
